module.exports = __webpack_public_path__ + "static/media/lockIconDark.121835e1.svg";